module.exports = __webpack_public_path__ + "static/favicon-7c561ff34a299abf1ddce7df7baf08d0.png";